import styled from 'styled-components';

import { pxToRem } from '@utils/converters';

import { MAX_VISIBLE_PRESENCE_AVATARS } from './constants';
import { UserAvatarList } from './user-avatar-list';

import { ActiveUser } from '../hooks/use-journey-presence';

type ActionPresenceIndicatorProps = {
  editors: ActiveUser[];
};

export const ActionPresenceIndicator = ({ editors }: ActionPresenceIndicatorProps) => {
  if (editors.length === 0) {
    return null;
  }

  return (
    <Container>
      <UserAvatarList
        users={editors}
        maxVisible={MAX_VISIBLE_PRESENCE_AVATARS}
        tooltipPlacement="top"
      />
    </Container>
  );
};

const Container = styled.div({
  position: 'absolute',
  top: pxToRem(-12),
  right: pxToRem(-12),
  zIndex: 10,
  pointerEvents: 'none',
});
